export const visit = (vm, at) => {
vm(require("./availability/cs.lyaml"));
vm(require("./typical-response-time/cs.lyaml"));
vm(require("./default/cs.lyaml"));
at({ "cs": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};